export function APICore() {
  // return '/omni/v1' //without LB
  return '/go-omni/v1' //with LB
}
export function APICoreV2() {
  return '/go-omni-v2' //with LB
}

export function APIReportPHP() {
  return '/omni-member/v1' //with LB
}


// WEBPACK FOOTER //
// ./src/utils/servicesApi.js